import { defineStore } from 'pinia'
import { ref } from 'vue'

import { VoteEvent } from '@/types/logger.types'

import { useLoggerStore } from './logger'

export type GameVote = { hru: string; reaction: VoteEvent }

const VOTES_LIMIT = 50

export const useVotesStore = defineStore(
    'votes',
    () => {
        const loggerStore = useLoggerStore()
        const votedGames = ref<GameVote[]>([])

        function updateGameVote({ hru, reaction }: { hru: string; reaction: VoteEvent }): void {
            const existingGameVote = votedGames.value.find((item) => hru === item?.hru)
            logVotes({
                prevReaction: existingGameVote?.reaction,
                reaction,
            })
            const newGameVote = { hru, reaction }
            votedGames.value = existingGameVote
                ? votedGames.value.map((item) => (hru === item.hru ? newGameVote : item))
                : [newGameVote, ...votedGames.value].slice(0, VOTES_LIMIT)
        }

        function logVotes({
            prevReaction,
            reaction,
        }: {
            prevReaction: VoteEvent | undefined
            reaction: VoteEvent
        }): void {
            const isLiked = prevReaction === 'reaction_like'
            const isDisliked = prevReaction === 'reaction_dislike'
            loggerStore.logEvent({
                event: 'custom_event',
                eventName: reaction,
            })
            if (isLiked && reaction === 'reaction_dislike') {
                loggerStore.logEvent({
                    event: 'custom_event',
                    eventName: 'reaction_unset_like',
                })
            } else if (isDisliked && reaction === 'reaction_like') {
                loggerStore.logEvent({
                    event: 'custom_event',
                    eventName: 'reaction_unset_dislike',
                })
            }
        }

        return {
            votedGames,
            updateGameVote,
        }
    },
    {
        persist: {
            pick: ['votedGames'],
        },
    },
)
